const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M241.28 457.902h92.38v-31.061H178.34v31.061h30.25M224.938 162.814h62.125v31.062h-62.125z",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#000000",
    opacity: 1,
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 224.938,
    cy: 85.624,
    r: 15.062,
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#000000",
    opacity: 1,
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 287.532,
    cy: 85.624,
    r: 15.062,
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#000000",
    opacity: 1,
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.344 504.5h-31.187c-17.121 0-31-13.879-31-31v-62.25c0-17.121 13.879-31 31-31h31.187c17.121 0 31 13.879 31 31v62.25c0 17.121-13.879 31-31 31zM116.22 411.312h31.062M116.22 442.375h31.062M116.22 473.438h31.062M395.842 504.5h-31.187c-17.121 0-31-13.879-31-31v-62.25c0-17.121 13.879-31 31-31h31.187c17.121 0 31 13.879 31 31v62.25c0 17.121-13.879 31-31 31zM364.718 411.312h31.062M364.718 442.375h31.062M364.718 473.438h31.062M224.938 380.25h62.125v46.594h-62.125zM193.875 349.188h124.249v31.062H193.875zM272.34 38.558h14.725c25.734 0 46.595 20.861 46.595 46.595v0c0 25.734-20.861 46.595-46.595 46.595h-62.13c-25.734 0-46.595-20.861-46.595-46.595v0c0-25.734 20.861-46.595 46.595-46.595h14.725",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#000000",
    opacity: 1,
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.61 162.814h-63.22c-42.586 0-77.108-34.522-77.108-77.108v-1.098c0-42.586 34.522-77.108 77.108-77.108h63.22c42.586 0 77.108 34.522 77.108 77.108v1.098c0 42.585-34.523 77.108-77.108 77.108zM419.21 135.639c-14.29-9.83-23.67-26.3-23.67-44.91 0-24.65 16.45-45.52 38.95-52.23v35.04c-4.69 4.24-7.65 10.38-7.65 17.19 0 5.84 2.17 11.18 5.75 15.26M467.45 105.989c3.58-4.08 5.75-9.42 5.75-15.26 0-6.81-2.96-12.95-7.65-17.19v-35.04c22.5 6.71 38.95 27.58 38.95 52.23 0 18.61-9.38 35.08-23.67 44.91M380.03 221.21c28.12-8.83 49.38-33.28 53.58-63.141M380.25 253.52c45.1-9.93 79.8-47.9 84.8-94.641",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#000000",
    opacity: 1,
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 450.02,
    cy: 131.69,
    r: 31.062,
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#000000",
    opacity: 1,
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.17 135.639c-14.29-9.83-23.67-26.3-23.67-44.91 0-24.65 16.45-45.52 38.95-52.23v35.04c-4.69 4.24-7.65 10.38-7.65 17.19 0 5.84 2.17 11.18 5.75 15.26M79.41 105.989c3.58-4.08 5.75-9.42 5.75-15.26 0-6.81-2.96-12.95-7.65-17.19v-35.04c22.5 6.71 38.95 27.58 38.95 52.23 0 18.61-9.38 35.08-23.67 44.91M78.39 158.069c4.2 29.86 25.46 54.32 53.58 63.15M46.95 158.879c5 46.73 39.7 84.711 84.8 94.641",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#000000",
    opacity: 1,
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61.98,
    cy: 131.69,
    r: 31.062,
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#000000",
    opacity: 1,
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.718 85.157V7.5M147.282 85.157V7.5M349.249 349.187H162.751c-17.121 0-31-13.879-31-31v-93.312c0-17.121 13.879-31 31-31h186.498c17.121 0 31 13.879 31 31v93.312c0 17.121-13.879 31-31 31z",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#000000",
    opacity: 1,
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.88 224.94h30.31c8.28 0 15 6.71 15 15v32.12c0 8.29-6.72 15-15 15H177.81c-8.28 0-15-6.71-15-15v-32.12c0-8.29 6.72-15 15-15h93.38M193.875 318.125h124.25",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#000000",
    opacity: 1,
    className: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRover);
export default __webpack_public_path__ + "static/media/rover.5eb804c2121b0e122c4ac537100bca2e.svg";
export { ForwardRef as ReactComponent };